import { Box, Skeleton as MuiSkeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

function SuggestionsFormSkeleton() {
  return (
    <>
      <Skeleton animation="wave" variant="rounded" width="100%" height={40} />
      <Skeleton animation="wave" variant="rounded" width="100%" height={200} sx={{ mt: 1.5 }} />
      <Skeleton animation="wave" variant="rounded" width="100%" height={60} sx={{ mt: 1.5 }} />

      <Box display="flex" alignItems="center" mt={3}>
        <Skeleton animation="wave" variant="rounded" width={200} height={20} sx={{ mr: 3 }} />
        <Skeleton animation="wave" variant="rounded" width="100%" height={40} />
      </Box>
      <Box display="flex" alignItems="center" mt={3}>
        <Skeleton animation="wave" variant="rounded" width={200} height={20} sx={{ mr: 3 }} />
        <Skeleton animation="wave" variant="rounded" width="100%" height={40} />
      </Box>
      <Box display="flex" alignItems="center" mt={3}>
        <Skeleton animation="wave" variant="rounded" width={200} height={20} sx={{ mr: 3 }} />
        <Skeleton animation="wave" variant="rounded" width="100%" height={40} />
      </Box>
    </>
  );
}

const Skeleton = styled(MuiSkeleton, { label: 'Skeleton' })(({ theme }) => ({
  '&::after': {
    background: `linear-gradient(
      90deg,
      transparent,
      ${theme.palette.custom.inputHoverBackground},
      transparent
    )`,
  },
}));

export default SuggestionsFormSkeleton;
